import script from "./home-page.vue?vue&type=script&setup=true&lang=js"
export * from "./home-page.vue?vue&type=script&setup=true&lang=js"

import "./home-page.vue?vue&type=style&index=0&id=3450ed7c&lang=scss"

const __exports__ = script;

export default __exports__